import React from 'react';
import SashiDo from 'lib/SashiDo';
import DashboardView from 'dashboard/DashboardView.react';
import EmptyState from 'components/EmptyState/EmptyState.react';
import history from 'dashboard/history';
import LoaderContainer from 'components/LoaderContainer/LoaderContainer.react';
import Button from 'components/Button/Button.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import SashiDoParse from '../SashiDoParse';
import styles from './Settings.scss';
import BuildLogView from './BuildLogView.react';

const { SASHIDO_API_URL, SASHIDO_API_ID, SASHIDO_API_JS_KEY } = process.env;

const Build = SashiDoParse.Object.extend('Build');
const BuildLogStream = SashiDoParse.Object.extend('BuildLogStream');

export default class BuildLog extends DashboardView {
  constructor() {
    super();
    this.section = 'Runtime';
    this.subsection = 'Builds';

    this.state = {
      loading: true,
      logs: [],
      phase: 'New',
    };
  }

  async componentDidMount() {
    const build = await SashiDo.getBuildLog({
      buildId: this.props.params.buildId,
    });

    if (build) {
      const logsArr = build.text.replace(/[\r\n]\s*[\r\n]/g, '\n').split('\n');
      const newLogs = logsArr.map((item, i) => {
        return {
          objectId: i,
          text: item || ' ',
        };
      }).filter(r => r.text !== ' ');

      this.setState({
        logs: newLogs,
        phase: 'Complete',
      });

      return null;
    }

    const logs = await SashiDo.getBuildLogFromStream({
      buildId: this.props.params.buildId,
    });

    if (logs.length === 0) {
      this.runLiveQuery();
      this.setState({ logs: [] });
      return null;
    }

    const newPhase = (logs[logs.length - 1] || {}).build;

    this.setState({
      logs,
      phase: newPhase.phase,
    }, () => {
      this.runLiveQuery();
    });
  }

  runLiveQuery() {
    const userObject = JSON.parse(window.localStorage.getItem(`SashiDo/${SASHIDO_API_ID}/currentUser`));
    const sessionToken = userObject ? userObject.sessionToken : '';

    this.client = new SashiDoParse.LiveQueryClient({
      applicationId: SASHIDO_API_ID,
      serverURL: SASHIDO_API_URL.replace('https', 'wss'),
      javascriptKey: SASHIDO_API_JS_KEY,
    });

    this.client.open();


    const queryBuild = new SashiDoParse.Query(Build);
    queryBuild.equalTo('app', { __type: 'Pointer', className: 'App', objectId: this.context.currentApp.id });
    this.subscriptionBuild = this.client.subscribe(queryBuild, sessionToken);

    // Build
    this.subscriptionBuild.on('update', (obj) => {
      const { phase } = obj.attributes;
      this.setState({
        phase,
      });
    });


    // BuildLogStream
    const query = new SashiDoParse.Query(BuildLogStream);
    query.include('build');
    query.equalTo('build', { __type: 'Pointer', className: 'Build', objectId: this.props.params.buildId });
    this.subscription = this.client.subscribe(query, sessionToken);

    this.subscription.on('create', (obj) => {
      if (location.pathname.includes(this.props.params.buildId)) {
        this.setState((prevState) => {
          return {
            logs: [...(prevState.logs || []), { objectId: obj.id, ...obj.attributes }],
          };
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.client) {
      this.client.close();
      this.client = null;
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  onStartBuildHandler = async () => {
    await SashiDo.startBuild({ appId: this.context.currentApp.id });
  }

  renderContent() {
    const { logs, phase } = this.state;
    return (
      <div>
        <Toolbar section={this.section} subsection="Build Log">
          <Button
            value="Go Back"
            onClick={() => history.push(`/products/apps/${this.context.currentApp.slug}/runtime/builds`)} />
        </Toolbar>
        <div className={[styles.settings_page, this.state.showFooter ? styles.showFooter : ''].join(' ')}>
          <div className={styles.holder}>
            <LoaderContainer loading hideAnimation={this.state.loading} inner>
              {
                logs.length === 0
                  ?
                    <EmptyState
                      title="There are no logs available for this build"
                      cta="Go Back"
                      action={() => history.push(`/products/apps/${this.context.currentApp.slug}/runtime/builds`)} />
                  :
                    <BuildLogView
                      logs={logs}
                      phase={phase} />
              }
            </LoaderContainer>
          </div>
        </div>
      </div>
    );
  }
}
